"use client";

import type { ProductPricesWithDiscount } from "@frend-digital/centra-legacy/types/product";
import clsx from "clsx";

import useLocation from "@/lib/centra/hooks/useLocation";
import usePriceList from "@/lib/centra/hooks/useSelection/cart/usePriceList";

import Skeleton from "@/components/ui/Skeleton";
import { Suspense } from "react";
import styles from "./price.module.css";

const UnsuspendedPrice = ({
  prices,
  className,
}: {
  prices?: ProductPricesWithDiscount | ProductPricesWithDiscount[];
  className?: string;
}) => {
  const priceList = usePriceList(prices);

  const location = useLocation();

  const isDiscounted = priceList.productOnSale;

  if (isDiscounted)
    return (
      <div className={clsx(className, styles.discounted__wrapper)}>
        <span className={styles.price__after__discount}>
          <p className="sr-only">
            {"Price after " + priceList.discountPercent + "% discount."}
          </p>
          <span>{priceList.priceAsNumber}</span>
          <span className={styles.discount__number}> {location.currency}</span>
        </span>
        <span className={clsx(className, styles.price__before__discount)}>
          <p className="sr-only">{"Price before discount."}</p>
          <span className={styles.discount__number}>
            {priceList.priceBeforeDiscountAsNumber}
          </span>
          <span className={styles.discount__number}> {location.currency}</span>
        </span>
      </div>
    );
  return (
    <span className={className}>
      {priceList.priceAsNumber && priceList.currency ? (
        `${priceList.priceAsNumber} ${priceList.currency}`
      ) : (
        <span aria-hidden style={{ visibility: "hidden" }}>
          0
        </span>
      )}
    </span>
  );
};

const Price: typeof UnsuspendedPrice = props => {
  return (
    <Suspense fallback={<Skeleton height={"24px"} width={"100px"} />}>
      <UnsuspendedPrice {...props} />
    </Suspense>
  );
};

export default Price;
